import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { INVOICE } from '../../../../utils/ServiceUtils';

export interface IListInvoiceStatusRequest extends IBaseRequest {
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    orderByType?: string;
    treeHandle?: string;
}

export class ListInvoiceStatusRequest extends BaseRequest implements IListInvoiceStatusRequest {
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    orderByType?: string;
    treeHandle?: string;

    constructor(server: string, session: string, otherOptions?: any) {
        super(server, session);
        this.limit = otherOptions?.limit;
        this.offset = otherOptions?.offset;
        this.orderBy = otherOptions?.orderBy;
        this.countOnly = otherOptions?.countOnly;
        this.orderByType = otherOptions?.orderByType;
        this.treeHandle = otherOptions?.treeHandle;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.orderByType, 'orderByType');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');

        return super.wrapperXml(INVOICE.listInvoiceStatus, parameters);
    }
}
